import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "bootstrap/scss/bootstrap.scss";
import { StateProvider } from "./Components/StateProvider";
import reducer, { initialState } from "./Components/Reducer";
import { BrowserRouter } from "react-router-dom";
import Scroll from "./Components/ScrollTop/Scroll";
// import Search from "./Components/Search";

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
    <StateProvider initialState={initialState} reducer={reducer}>
    
      <App />
      <Scroll/>
     
    </StateProvider>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById("root")
);
